export class TranslationTexts {

    /**
     *
     * Don't define translation strings everywhere in the client.
     * Use something like this to make it easier for both you and the translator to know what text are being used.
     *
     */

        // WIN, number of XWays
    public static WAYS_WON: string = "Ways Won";
    public static WAY_WON: string = "Way Won";

}
